module.exports = __webpack_public_path__ + "static/media/Neeko.9aba9b1c.png";